export const API_URL = "https://airtap-backend.vercel.app/";

export const CHECK_LOGIN = "checkLogin";
export const USER_DETAILS = "getUserDetails";
export const UPLOAD_IMAGE = "upload";
export const UPDATE_PERSONAL_DETAILS = "personalDetails";
export const UPDATE_COMPANY_DETAILS = "companyDetails";
export const UPDATE_SOCIAL_DETAILS = "socialDetails";
export const UPDATE_MOBILE_DETAILS = "mobileDetails";
